import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export class UzenetTableDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.uzenetekTipus = null;
		/** @type {number} */
		this.mentValaszIn = null;
		/** @type {string} */
		this.levelCim = null;
		/** @type {Date} */
		this.kuldesIdeje = null;
	}

	/**
	 * @typedef {Object} _UzenetTableDtoProps
	 * @property {NamedDto} uzenetekTipus
	 * @property {number} mentValaszIn
	 * @property {string} levelCim
	 * @property {Date} kuldesIdeje
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _UzenetTableDtoProps} UzenetTableDtoProps
	 */
	/**
	 *
	 * @param {UzenetTableDtoProps} props
	 * @returns {UzenetTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.mentValaszIn = props.mentValaszIn;
		this.levelCim = props.levelCim;
		this.kuldesIdeje = props.kuldesIdeje !== null ? new Date(props.kuldesIdeje) : null;
		this.uzenetekTipus = props.uzenetekTipus !== null ? new NamedDto().setup(props.uzenetekTipus) : null;
		return this;
	}
}

export default UzenetTableDto;
